import {ClinicInfoSettingsTypes} from '@/src/profile/accountSettings/containers/types/ClinicInfoSettingsTypes';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

import css from '../styles/ClinicInfoSettingsLayout.module.css';

interface ClinicInfoSettingsLayoutProps extends ClinicInfoSettingsTypes {
  onEditClinicInfoClick: (...args: any[]) => any;
}

const ClinicInfoSettingsLayout = ({
  clinicName,
  userName,
  email,
  website,
  onEditClinicInfoClick,
}: ClinicInfoSettingsLayoutProps): JSX.Element => {
  return (
    <div className={css.mainWrapper}>
      <div className={css.info}>
        {Boolean(clinicName) && (
          <Text
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
          >
            {clinicName}
          </Text>
        )}
        {Boolean(userName) && (
          <Text
            fontSize={Text.FONT_SIZE.SIZE_16}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
          >
            {userName}
          </Text>
        )}
        {Boolean(email) && (
          <Text
            fontSize={Text.FONT_SIZE.SIZE_16}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
          >
            {email}
          </Text>
        )}
        {Boolean(website) && (
          <a
            className={css.link}
            href={website.includes('http') ? website : `//${website}`}
            target="_blank"
            rel="noreferrer"
            title={website}
          >
            <Text
              fontSize={Text.FONT_SIZE.SIZE_16}
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
              color={Text.COLOR.GRADIENT}
              tagComponent={Text.TAG.SPAN}
              display={Text.DISPLAY.INLINE_BLOCK}
              isOneLine
            >
              {website}
            </Text>
          </a>
        )}
      </div>
      <div className={css.rightActionSection}>
        <div className={css.buttonWrapper}>
          <Button
            height={Button.HEIGHT.SMALL}
            type={Button.TYPES.BUTTON}
            onClick={onEditClinicInfoClick}
            color={Button.COLOR.SECONDARY}
            border={Button.BORDER.BOLD}
          >
            <Text
              fontSize={Text.FONT_SIZE.SIZE_16}
              fontWeight={Text.FONT_WEIGHT.MEDIUM}
              tagComponent={Text.TAG.SPAN}
            >
              <TextLocal id="profile.edit-clinic-info" />
            </Text>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClinicInfoSettingsLayout;
